import React from 'react';

import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import type { useChannels } from '@mint-lib/hooks';
import { Settings } from '@mint-lib/icons';
import { Platform } from '@mint-lib/routing-context';
import { TruncateText } from '@mint-lib/tw-components';

import { ChannelIcon } from '@myn/mui';

import type { SuggestionGridType } from '../../../../types/suggestion.js';
import { DefaultCell } from './DefaultCell.jsx';

const LevelCell = (
  props: ICellRendererParams<SuggestionGridType> & {
    channels: ReturnType<typeof useChannels>;
    platformByLabel: Record<string, Platform>;
  },
) => {
  const { data, value, channels, platformByLabel } = props;
  const suggestionType = data?.type;

  const displayContent = () => {
    if (suggestionType === 'channel') {
      const currentChannel = channels[value];
      return currentChannel ? (
        <>
          <ChannelIcon component={currentChannel.icon} />
          <TruncateText>{currentChannel.name}</TruncateText>
        </>
      ) : (
        <TruncateText>{value}</TruncateText>
      );
    }

    if (suggestionType === 'platform') {
      const currentPlatform = platformByLabel[value];

      return (
        <>
          {currentPlatform?.logo ? (
            <img
              src={currentPlatform.logo}
              alt="Platform icon"
              width="18px"
              height="18px"
            />
          ) : (
            <Settings className="size-4.5 fill-icon-primary" />
          )}
          <TruncateText>{currentPlatform?.label ?? value}</TruncateText>
        </>
      );
    }

    return <TruncateText>{value}</TruncateText>;
  };

  return <DefaultCell>{displayContent()}</DefaultCell>;
};

export { LevelCell };
